import { useLocation } from "@gatsbyjs/reach-router";

export const useIsHelloPage = () => {
  const location = useLocation();
  return location.pathname.includes("hello");
};
